import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import MasterClassIndex from './masterclass/health';

export default function (props) {
  useEffect(() => {
    navigate('/masterclass/health/' + location.search);
  }, []);
  return <MasterClassIndex />;
}
